// The Angular list page hardcodes this path, so it cannot change without that file changing too.
// See list_playlists_dir.js.
export function playlistEditorPath({ playlistId }: { playlistId: string }) {
    return `/editor/playlist/${playlistId}/edit`;
}
